import axios from 'axios'
import { Notification } from 'element-ui'
const Url = process.env.VUE_APP_BASE_HOST + '/api/'
// const Url = '/api/'
const RequestEnums = {
  TIMEOUT: 20000,
  BAD_PARAMS: 422, // 参数错误
  TIPS: 400, // 登录失效
  OVERDUE: 401, // 登录失效
  NO: 403, // 授权失效
  FAIL: 500, // 请求失败
  SUCCESS: 200 // 请求成功
}
const config = {
  // 默认地址
  baseURL: Url,
  // 设置超时时间
  timeout: RequestEnums.TIMEOUT,
  // 跨域时候允许携带凭证
  withCredentials: true
}

class RequestHttp {
  // 定义成员变量并指定类型
  service
  constructor (config) {
    // 实例化axios
    this.service = axios.create(config)

    /**
     * 请求拦截器
     * 客户端发送请求 -> [请求拦截器] -> 服务器
     * token校验(JWT) : 接受服务器返回的token,存储到vuex/pinia/本地储存当中
     */
    this.service.interceptors.request.use(
      // AxiosRequestConfig
      (config) => {
        // const token = sessionStore().token || '';
        const token = localStorage.getItem('token') || ''
        return {
          ...config,
          headers: {
            Authorization: 'Bearer ' + token, // 请求头中携带token信息
            'Content-Type': 'application/json;charset=utf-8',
            'Accept': 'application/json'
          }
        }
      },
      (error) => {
        // 请求报错
        return {code: 500, msg: error.message}
      }
    )

    /**
     * 响应拦截器
     * 服务器换返回信息 -> [拦截统一处理] -> 客户端JS获取到信息
     */
    this.service.interceptors.response.use(
      (response) => {
        const { data } = response // 解构
        if (data.code !== 0) {
          Notification({
            title: '提示',
            type: 'error',
            message: data.message
          })
          return {code: data.code, msg: data.message}
        }
        // 全局错误信息拦截（防止下载文件得时候返回数据流，没有code，直接报错）
        // if (data.code && data.code !== RequestEnums.SUCCESS) {
        //   message.error(data) // 此处也可以使用组件提示报错信息
        //   return Promise.reject(data)
        // }
        return data
      },
      (error) => {
        const { response } = error
        if (response) {
          if (response.data) {
            if (response.status === RequestEnums.OVERDUE) {
              Notification({
                title: '提示',
                type: 'error',
                message: response.data.msg
              })
              return {code: response.status, msg: response.data.msg}
            }
            Notification({
              title: '提示',
              type: 'error',
              message: '数据错误'
            })
            return {code: response.status, msg: '数据错误'}
          } else {
            Notification({
              title: '提示',
              type: 'error',
              message: '网络连接失败'
            })
            return {code: response.status, msg: '网络连接失败'}
          }
        }
        Notification({
          title: '提示',
          type: 'error',
          message: error.message
        })
        return {code: response.status, msg: error.message}
      }
    )
  }

  // 常用方法封装
  get (url, params) {
    return this.service.get(url, { params })
  }
  post (url, params) {
    return this.service.post(url, params)
  }
  put (url, params) {
    return this.service.put(url, params)
  }
  delete (url, params) {
    return this.service.delete(url, { params })
  }
}

// 导出一个实例对象
export default new RequestHttp(config)
